export default {
  body: document.querySelector('body'),
  search: document.querySelector('.search'),
  searchForm: document.querySelector('.search__form'),
  formInput: document.querySelector('.form__input'),
  formAddToFavorites: document.querySelector('.form__add-to-favorites'),
  formIconStar: document.querySelector('.form__icon-star'),
  favoritesArrowLeft: document.querySelector('.favorites__arrow-left'),
  favoritesList: document.querySelector('.favorites__list'),
  searchFavorites: document.querySelector('.search__favorites'),

  sunriseToday: document.querySelector('.today__dawn'),
  sunsetToday: document.querySelector('.today__sunset'),

  switchDaysBtn: document.querySelector('.switch-days-btn'),
  forecastToday: document.querySelector('.forecast__today'),
  currentWeather: document.querySelector('.current-weather'),
  citation: document.querySelector('.citation'),
  chartShow: document.querySelector('.chart__show'),
  chartHide: document.querySelector('.chart__hide'),
  chart: document.querySelector('.chart'),
  chartWrapper: document.querySelector('.chart__wrapper'),
  schedule: document.querySelector('#schedule'),
  scheduleWrapper: document.querySelector('.schedule__wrapper'),

  forecastFiveDays: document.querySelector('.forecast__five-days'),
  forecastFiveDaysCity: document.querySelector('.five-days__city-name'),
  forecastFiveDaysList: document.querySelector('.five-days__list'),
  forecastMoreInfo: document.querySelector('.more-information__list'),
  moreInfoWrapper: document.querySelector('.five-days__more-information'),

  fiveDaysBtn: document.querySelector('.five-days__btn'),
  switchToFiveDaysBtn: document.querySelector('.five-days-forecast-js'),
  switchToTodayBtn: document.querySelector('.today-forecast-js'),
  fiveDaysPrevDayBtn: document.querySelector('.five-days__prev-day-btn'),
  fiveDaysNextDayBtn: document.querySelector('.five-days__next-day-btn'),
  fiveDaysMoreInfoBtn: document.querySelector(
    '.five-days__more-information-btn',
  ),
  fiveDaysMoreInfoScrollbar: document.querySelector('.swiper-scrollbar'),
};
